module.exports = __webpack_public_path__ + "static/media/buxton-19.4e7b2b12.jpg";